import { momentFormat } from '@/pages/dashboard/utils/_config/filtersTimeFormat';
import moment from 'moment'

const currDate = moment();
const currWeek = currDate.week();
const currMonth = currDate.month();
const timeRange: any = {
  Day: [
    momentFormat(moment().subtract(14, "day")),
    momentFormat(moment().subtract(1, "day")),
  ],
  Week: [
    momentFormat(
      moment()
        .week(currWeek - 6)
        .startOf("isoWeek")
    ),
    momentFormat(
      moment()
        .week(currWeek - 1)
        .endOf("isoWeek")
    ),
  ],
  LastWeek: [
    momentFormat(
      moment()
        .week(currWeek - 1)
        .startOf("isoWeek")
    ),
    momentFormat(
      moment()
        .week(currWeek - 1)
        .endOf("isoWeek")
    ),
  ],
  LastMonth: [
    momentFormat(
      moment()
        .month(currMonth - 1)
        .startOf('month'),
    ),
    momentFormat(
      moment()
        .month(currMonth - 1)
        .endOf('month'),
    ),
  ],
  Month: [
    momentFormat(
      moment()
        .month(currMonth - 6)
        .startOf("month")
    ),
    momentFormat(
      moment()
        .month(currMonth - 1)
        .endOf("month")
    ),
  ],
};

export { timeRange };
